let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ir9sm")).then(() => parcelRequire('gOk31'));